module.exports = __webpack_public_path__ + "static/media/8.85200345.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/九宫格选中态/8.png
// module id = 1077
// module chunks = 0